"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var core_http_1 = require("@azure/core-http");
var constants_1 = require("./constants");
var eventIds = new Map([
    ["chatMessageReceived", 200],
    ["typingIndicatorReceived", 245],
    ["readReceiptReceived", 246],
    ["chatMessageEdited", 247],
    ["chatMessageDeleted", 248],
    ["chatThreadCreated", 257],
    ["chatThreadPropertiesUpdated", 258],
    ["chatThreadDeleted", 259],
    ["participantsAdded", 260],
    ["participantsRemoved", 261]
]);
var publicTeamsUserPrefix = "8:orgid:";
var dodTeamsUserPrefix = "8:dod:";
var gcchTeamsUserPrefix = "8:gcch:";
var teamsVisitorUserPrefix = "8:teamsvisitor:";
var phoneNumberPrefix = "4:";
var acsUserPrefix = "8:acs:";
var spoolUserPrefix = "8:spool:";
exports.toMessageHandler = function (event, listener) {
    var eventId = eventIds.get(event);
    return {
        handleMessage: function (message) {
            var genericPayload = null;
            if (message === null || message === void 0 ? void 0 : message.rawBody) {
                genericPayload = JSON.parse(message.rawBody);
            }
            if (genericPayload === null || genericPayload.eventId !== eventId) {
                return undefined;
            }
            var eventPayload = toEventPayload(event, genericPayload);
            if (eventPayload === null) {
                return undefined;
            }
            listener(eventPayload);
            return { isHandled: true, resultCode: 200 };
        }
    };
};
var toEventPayload = function (event, genericPayload) {
    if (event === "chatMessageReceived") {
        var payload = genericPayload;
        var eventPayload = {
            threadId: payload.groupId,
            sender: constructIdentifierKindFromMri(payload.senderId),
            senderDisplayName: payload.senderDisplayName,
            recipient: constructIdentifierKindFromMri(payload.recipientMri),
            id: payload.messageId,
            createdOn: new Date(payload.originalArrivalTime),
            version: payload.version,
            type: payload.messageType,
            message: payload.messageBody,
            metadata: parseMetadata(payload.acsChatMessageMetadata)
        };
        return eventPayload;
    }
    if (event === "chatMessageEdited") {
        var payload = genericPayload;
        var eventPayload = {
            threadId: payload.groupId,
            sender: constructIdentifierKindFromMri(payload.senderId),
            senderDisplayName: payload.senderDisplayName,
            recipient: constructIdentifierKindFromMri(payload.recipientMri),
            id: payload.messageId,
            createdOn: new Date(payload.originalArrivalTime),
            version: payload.version,
            message: payload.messageBody,
            editedOn: new Date(payload.edittime),
            type: payload.messageType,
            metadata: parseMetadata(payload.acsChatMessageMetadata)
        };
        return eventPayload;
    }
    if (event === "chatMessageDeleted") {
        var payload = genericPayload;
        var eventPayload = {
            threadId: payload.groupId,
            sender: constructIdentifierKindFromMri(payload.senderId),
            senderDisplayName: payload.senderDisplayName,
            recipient: constructIdentifierKindFromMri(payload.recipientMri),
            id: payload.messageId,
            createdOn: new Date(payload.originalArrivalTime),
            version: payload.version,
            deletedOn: new Date(payload.deletetime),
            type: payload.messageType
        };
        return eventPayload;
    }
    if (event === "typingIndicatorReceived") {
        var payload = genericPayload;
        var eventPayload = {
            threadId: payload.groupId,
            sender: constructIdentifierKindFromMri(payload.senderId),
            senderDisplayName: payload.senderDisplayName,
            recipient: constructIdentifierKindFromMri(payload.recipientMri),
            version: payload.version,
            receivedOn: new Date(payload.originalArrivalTime)
        };
        return eventPayload;
    }
    if (event === "readReceiptReceived") {
        var payload = genericPayload;
        var readReceiptMessageBody = JSON.parse(payload.messageBody);
        var consumptionHorizon = readReceiptMessageBody.consumptionhorizon.split(";");
        var eventPayload = {
            threadId: payload.groupId,
            sender: constructIdentifierKindFromMri(payload.senderId),
            senderDisplayName: "",
            recipient: constructIdentifierKindFromMri(payload.recipientMri),
            chatMessageId: payload.messageId,
            readOn: new Date(+consumptionHorizon[1])
        };
        return eventPayload;
    }
    if (event === "chatThreadCreated") {
        var payload = genericPayload;
        var createdByPayload = JSON.parse(unescape(payload.createdBy));
        var membersPayload = JSON.parse(unescape(payload.members));
        var propertiesPayload = JSON.parse(unescape(payload.properties));
        var createdBy = {
            id: constructIdentifierKindFromMri(createdByPayload.participantId),
            displayName: createdByPayload.displayName
        };
        var chatParticipants = membersPayload.map(function (m) {
            return {
                id: constructIdentifierKindFromMri(m.participantId),
                displayName: m.displayName
            };
        });
        var eventPayload = {
            threadId: payload.threadId,
            createdOn: new Date(payload.createTime),
            createdBy: createdBy,
            version: payload.version,
            participants: chatParticipants,
            properties: propertiesPayload
        };
        return eventPayload;
    }
    if (event === "chatThreadPropertiesUpdated") {
        var payload = genericPayload;
        var updatedByPayload = JSON.parse(unescape(payload.editedBy));
        var propertiesPayload = JSON.parse(unescape(payload.properties));
        var updatedBy = {
            id: constructIdentifierKindFromMri(updatedByPayload.participantId),
            displayName: updatedByPayload.displayName
        };
        var eventPayload = {
            threadId: payload.threadId,
            updatedOn: new Date(payload.editTime),
            updatedBy: updatedBy,
            version: payload.version,
            properties: propertiesPayload
        };
        return eventPayload;
    }
    if (event === "chatThreadDeleted") {
        var payload = genericPayload;
        var deletedByPayload = JSON.parse(unescape(payload.deletedBy));
        var deletedBy = {
            id: constructIdentifierKindFromMri(deletedByPayload.participantId),
            displayName: deletedByPayload.displayName
        };
        var eventPayload = {
            threadId: payload.threadId,
            deletedOn: new Date(payload.deleteTime),
            deletedBy: deletedBy,
            version: payload.version
        };
        return eventPayload;
    }
    if (event === "participantsAdded") {
        var payload = genericPayload;
        var addedByPayload = JSON.parse(unescape(payload.addedBy));
        var participantsAddedPayload = JSON.parse(unescape(payload.participantsAdded));
        var addedBy = {
            id: constructIdentifierKindFromMri(addedByPayload.participantId),
            displayName: addedByPayload.displayName
        };
        var chatParticipants = participantsAddedPayload.map(function (m) {
            return {
                id: constructIdentifierKindFromMri(m.participantId),
                displayName: m.displayName,
                shareHistoryTime: new Date(m.shareHistoryTime)
            };
        });
        var eventPayload = {
            threadId: payload.threadId,
            addedOn: new Date(payload.time),
            addedBy: addedBy,
            version: payload.version,
            participantsAdded: chatParticipants
        };
        return eventPayload;
    }
    if (event === "participantsRemoved") {
        var payload = genericPayload;
        var removedByPayload = JSON.parse(unescape(payload.removedBy));
        var participantsRemovedPayload = JSON.parse(unescape(payload.participantsRemoved));
        var removedBy = {
            id: constructIdentifierKindFromMri(removedByPayload.participantId),
            displayName: removedByPayload.displayName
        };
        var chatParticipants = participantsRemovedPayload.map(function (m) {
            return {
                id: constructIdentifierKindFromMri(m.participantId),
                displayName: m.displayName,
                shareHistoryTime: new Date(m.shareHistoryTime)
            };
        });
        var eventPayload = {
            threadId: payload.threadId,
            removedOn: new Date(payload.time),
            removedBy: removedBy,
            version: payload.version,
            participantsRemoved: chatParticipants
        };
        return eventPayload;
    }
    return null;
};
exports.toLogProvider = function (logger) {
    return {
        log: function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            return logger.info(message);
        },
        warn: function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            return logger.warning(message);
        },
        error: function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            return logger.error(message);
        },
        debug: function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            return logger.verbose(message);
        },
        info: function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            return logger.verbose(message);
        }
    };
};
exports.toTelemetrySender = function (logger) {
    return {
        logEvent: function (clientEvent) { return logger.info(clientEvent); }
    };
};
var constructIdentifierKindFromMri = function (mri) {
    if (mri.startsWith(publicTeamsUserPrefix)) {
        return {
            kind: "microsoftTeamsUser",
            rawId: mri,
            microsoftTeamsUserId: mri.substring(publicTeamsUserPrefix.length),
            isAnonymous: false,
            cloud: "public"
        };
    }
    else if (mri.startsWith(dodTeamsUserPrefix)) {
        return {
            kind: "microsoftTeamsUser",
            rawId: mri,
            microsoftTeamsUserId: mri.substring(dodTeamsUserPrefix.length),
            isAnonymous: false,
            cloud: "dod"
        };
    }
    else if (mri.startsWith(gcchTeamsUserPrefix)) {
        return {
            kind: "microsoftTeamsUser",
            rawId: mri,
            microsoftTeamsUserId: mri.substring(gcchTeamsUserPrefix.length),
            isAnonymous: false,
            cloud: "gcch"
        };
    }
    else if (mri.startsWith(teamsVisitorUserPrefix)) {
        return {
            kind: "microsoftTeamsUser",
            rawId: mri,
            microsoftTeamsUserId: mri.substring(teamsVisitorUserPrefix.length),
            isAnonymous: true
        };
    }
    else if (mri.startsWith(phoneNumberPrefix)) {
        return {
            kind: "phoneNumber",
            rawId: mri,
            phoneNumber: mri.substring(phoneNumberPrefix.length)
        };
    }
    else if (mri.startsWith(acsUserPrefix) || mri.startsWith(spoolUserPrefix)) {
        return { kind: "communicationUser", communicationUserId: mri };
    }
    else {
        return { kind: "unknown", id: mri };
    }
};
var parseMetadata = function (metadata) {
    if (metadata === undefined || metadata === null || metadata === "" || metadata === "null") {
        return {};
    }
    return JSON.parse(metadata);
};
function base64decode(encodedString) {
    return !core_http_1.isNode ? atob(encodedString) : Buffer.from(encodedString, "base64").toString();
}
exports.base64decode = base64decode;
var parseJWT = function (token) {
    var _a = token === null || token === void 0 ? void 0 : token.split("."), payload = _a[1];
    if (payload === undefined) {
        throw new Error("Invalid token");
    }
    payload = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(base64decode(payload))));
};
exports.getCloudTypeFromCredential = function (credential) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, jwtToken, parsedJwtToken, identityMri;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, credential.getToken()];
            case 1:
                accessToken = _a.sent();
                jwtToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.token;
                parsedJwtToken = parseJWT(jwtToken);
                identityMri = parsedJwtToken.skypeid;
                return [2 /*return*/, getCloudTypeFromSkypeId(identityMri)];
        }
    });
}); };
function getCloudTypeFromSkypeId(skypeId) {
    var cloudPrefix = skypeId.substring(0, skypeId.indexOf(":"));
    switch (cloudPrefix) {
        case constants_1.CloudPrefix.OrgId:
        case constants_1.CloudPrefix.Acs:
        case constants_1.CloudPrefix.Spool: {
            return constants_1.CloudType.Public;
        }
        case constants_1.CloudPrefix.GccHigh:
        case constants_1.CloudPrefix.GccHighAcs: {
            return constants_1.CloudType.GccHigh;
        }
        case constants_1.CloudPrefix.Dod:
        case constants_1.CloudPrefix.DodAcs: {
            return constants_1.CloudType.Dod;
        }
        default: {
            return constants_1.CloudType.Public;
        }
    }
}
